// Build-time env vars (webpack DefinePlugin only replaces literal access)
const buildTimeEnv = {
  REACT_APP_PROTOCOL: process.env.REACT_APP_PROTOCOL,
  REACT_APP_HOSTNAME: process.env.REACT_APP_HOSTNAME,
  REACT_APP_API_PORT: process.env.REACT_APP_API_PORT,
  REACT_APP_WEBSOCKET: process.env.REACT_APP_WEBSOCKET,
  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY:
    process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  REACT_APP_LIFF_ID: process.env.REACT_APP_LIFF_ID,
  REACT_APP_PROVISION_SERVER_HOST: process.env.REACT_APP_PROVISION_SERVER_HOST,
  REACT_APP_PROVISION_SERVER_PORT: process.env.REACT_APP_PROVISION_SERVER_PORT,
  REACT_APP_PROVISION_SERVER_IP: process.env.REACT_APP_PROVISION_SERVER_IP,
};

// Runtime config (window._env_) takes priority over build-time env
const env = (key) =>
  (window._env_ && window._env_[key]) || buildTimeEnv[key] || "";

export const CONFIG = {
  PROTOCOL: env("REACT_APP_PROTOCOL"),
  HOSTNAME: env("REACT_APP_HOSTNAME"),
  API_PORT: env("REACT_APP_API_PORT"),
  WEBSOCKET: env("REACT_APP_WEBSOCKET"),
  GOOGLE_RECAPTCHA_SITE_KEY: env("REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY"),
  LIFF_ID: env("REACT_APP_LIFF_ID"),
  PROVISION_SERVER_HOST: env("REACT_APP_PROVISION_SERVER_HOST"),
  PROVISION_SERVER_PORT: env("REACT_APP_PROVISION_SERVER_PORT"),
  PROVISION_SERVER_IP: env("REACT_APP_PROVISION_SERVER_IP"),
};

const portSuffix = CONFIG.API_PORT ? ":" + CONFIG.API_PORT : "";

export const API_BASE_URL = CONFIG.PROTOCOL + CONFIG.HOSTNAME + portSuffix;

export const WS_BASE_URL = CONFIG.WEBSOCKET + CONFIG.HOSTNAME + portSuffix;
